import { useTranslation } from 'react-i18next';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '../components/ui/dialog';
import { Button } from '../components/ui/button';

const Section = ({ title, content }) => (
  <section className="mb-6">
    <h3 className="text-sm font-semibold text-text_strong tracking-wide mb-2">{title}</h3>
    <p className="text-sm text-text_muted leading-relaxed">{content}</p>
  </section>
);

/**
 * Reusable legal-document modal.
 * Reads sections from i18n path `pages.<i18nKey>.sections` / `.title` / `.lastUpdated`.
 */
export const LegalDocumentModal = ({ open, onOpenChange, i18nKey, testIdPrefix = 'legal' }) => {
  const { t } = useTranslation();
  const sections = t(`pages.${i18nKey}.sections`, { returnObjects: true }) || [];

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className="max-w-2xl max-h-[85vh] flex flex-col p-0 gap-0"
        data-testid={`${testIdPrefix}-modal`}
      >
        <DialogHeader className="px-6 pt-6 pb-4 border-b border-border flex-shrink-0">
          <DialogTitle className="text-lg md:text-xl font-medium text-text_strong tracking-wide">
            {t(`pages.${i18nKey}.title`)}
          </DialogTitle>
          <p className="text-xs text-text_muted mt-1">{t(`pages.${i18nKey}.lastUpdated`)}</p>
        </DialogHeader>

        <div className="overflow-y-auto px-6 py-5 flex-1" data-testid={`${testIdPrefix}-modal-content`}>
          {Array.isArray(sections) && sections.map((s, i) => (
            <Section key={s.title || `section-${i}`} title={s.title} content={s.content} />
          ))}
        </div>

        <DialogFooter className="px-6 py-4 border-t border-border flex-shrink-0 sm:justify-end">
          <Button
            type="button"
            variant="outline"
            onClick={() => onOpenChange(false)}
            data-testid={`${testIdPrefix}-modal-close`}
          >
            {t('common.close')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
